export const UMB_SLUG = '/member-group';
